import { Nullable } from "@core/domain/types/nullable.type";
import { MedicalLeaveSubtypeEnumDto } from "@entity/data/dto/employee/medical-leave-subtype.dto";
import { MedicalLeaveSubtypeEnum } from "@entity/domain/models/employee/medical-leave-subtype.model";
import { injectable } from "inversify";

@injectable()
export class MedicalLeaveSubtypeEnumMapper {
    map(
        medicalLeaveSubtypeEnumDto: MedicalLeaveSubtypeEnumDto,
    ): Nullable<MedicalLeaveSubtypeEnum> {
        switch (medicalLeaveSubtypeEnumDto) {
            case MedicalLeaveSubtypeEnumDto.it_common:
                return MedicalLeaveSubtypeEnum.it_common;
            case MedicalLeaveSubtypeEnumDto.it_work_accident:
                return MedicalLeaveSubtypeEnum.it_work_accident;
            case MedicalLeaveSubtypeEnumDto.maternity_paternity:
                return MedicalLeaveSubtypeEnum.maternity_paternity;
            case MedicalLeaveSubtypeEnumDto.pregnancy_risk:
                return MedicalLeaveSubtypeEnum.pregnancy_risk;
            case MedicalLeaveSubtypeEnumDto.other:
                return MedicalLeaveSubtypeEnum.other;
            default:
                return null;
        }
    }

    reverse(
        medicalLeaveSubtypeEnum: MedicalLeaveSubtypeEnum,
    ): Nullable<MedicalLeaveSubtypeEnumDto> {
        switch (medicalLeaveSubtypeEnum) {
            case MedicalLeaveSubtypeEnum.it_common:
                return MedicalLeaveSubtypeEnumDto.it_common;
            case MedicalLeaveSubtypeEnum.it_work_accident:
                return MedicalLeaveSubtypeEnumDto.it_work_accident;
            case MedicalLeaveSubtypeEnum.maternity_paternity:
                return MedicalLeaveSubtypeEnumDto.maternity_paternity;
            case MedicalLeaveSubtypeEnum.pregnancy_risk:
                return MedicalLeaveSubtypeEnumDto.pregnancy_risk;
            case MedicalLeaveSubtypeEnum.other:
                return MedicalLeaveSubtypeEnumDto.other;
            default:
                return null;
        }
    }
}
